import React, { ChangeEvent } from 'react';
import {
  Label,
  Spinner,
  Icon,
} from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';
import { ASSET_ACCEPTED_TYPES } from '../../../../constants/scouting';
import { getApiUrl } from '../../../../utils/url';
import { Activity } from '../../../../types';

export type RegionNoteFormFileProps = {
  activity?: Activity;
  assetDeleted: boolean;
  file: File | null,
  setFile: (arg0: File | null) => void,
  incorrectFileFormat: boolean;
  setIncorrectFileFormat: React.Dispatch<React.SetStateAction<boolean>>
  assetLoaded: boolean;
  setAssetLoaded: React.Dispatch<React.SetStateAction<boolean>>
  onClickAssetDelete: (arg0: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  onChangeFile: (arg0: ChangeEvent<HTMLInputElement>) => void,
  assetClass: string;
};

export const RegionNoteFormFile = ({
  activity,
  assetDeleted,
  file,
  setFile,
  incorrectFileFormat,
  setIncorrectFileFormat,
  assetLoaded,
  setAssetLoaded,
  onChangeFile,
  onClickAssetDelete,
  assetClass,
}: RegionNoteFormFileProps) => {
  const editModeWithAsset =
    activity &&
    activity.assets &&
    activity.assets[0] &&
    !assetDeleted;

  return (
    <>
      <div className={styles.regionModalPhotoHeader}>
        <div className={styles.inputFileContainer}>
          <input
            id="file-input"
            accept={ASSET_ACCEPTED_TYPES.join(', ')}
            className={styles.inputFile}
            data-test-id="region-note-form-file-input"
            disabled={editModeWithAsset}
            key={file?.name ?? ''}
            onChange={onChangeFile}
            type="file"
          />
          <label
            htmlFor="file-input"
            className={
              editModeWithAsset
                ? styles.inputFileLabelDisabled
                : styles.inputFileLabel
            }
          >
            <Icon
              glyph={Icon.set.CAMERA}
              className={styles.inputFileIcon}
              data-test-id='region-note-form-file-icon'
            />
            {getMessage('region.note.addPhoto')}
          </label>
        </div>
        {file && (
          <Label
            cornerType="circular"
            density="comfortable"
            status="default"
            testId="region-note-form-photo-title"
          >
            {file?.name}
            <Icon
              glyph={Icon.set.REMOVE}
              onClick={() => {
                setFile(null);
                setIncorrectFileFormat(false);
              }}
              testId="region-note-form-remove-new-asset"
            />
          </Label>
        )}
      </div>
      {incorrectFileFormat && (
        <div
          className={styles.inputFileError}
          data-test-id="region-note-form-file-input-error"
        >
          {getMessage('scouting.form.incorrectFileFormat')}
        </div>
      )}
      {editModeWithAsset && (
        <div className={styles.assetContainer}>
          {!assetLoaded && (
            <Spinner data-test-id="region-note-form-asset-spinner" />
          )}
          <div
            className={assetClass}
            data-test-id="region-note-form-asset-container"
          >
            <img
              alt={getMessage('image.regionNote.form')}
              className={styles.assetImage}
              data-test-id="region-note-form-asset-img"
              onLoad={() =>
                setAssetLoaded(true)
              }
              src={getApiUrl(
                `/api/tenderfoot/${activity?.assets[0].uri}`
              )}
            />
            <Icon
              className={styles.removeAssetIcon}
              glyph={Icon.set.REMOVE}
              onClick={onClickAssetDelete}
              testId="region-note-form-remove-loaded-asset"
            />
          </div>
        </div>
      )}
    </>
  );
};
